import axios from 'axios';

axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

const _DEV = 0;
const _TESTE = 1;
const _PROD = 2;

const leanAspNetAPI = [
  'https://localhost:44330',
  'https://leanhc2.famema.br',
  'https://leanhc.famema.br',
];

export const dominioLeanAspNetAPI = axios.create({
  baseURL: leanAspNetAPI[_PROD],
});
